<template>
  <div>
    <v-dialog v-model="value" max-width="600px" @keydown.esc="dismiss()" @click:outside="dismiss()" scrollable>
      <v-form @submit.prevent="addCategory()" ref="form" :lazy-validation="true" :disabled="isLoading">
        <v-card>
          <v-card-title class="
              d-flex
              justify-space-between
              bg-gray-100
            ">
            <div>{{ $t('project.manage_category') }}</div>
            <v-btn icon @click="dismiss()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <div class="px-4 pt-4">
            <div class="flex gap-5 h-100">
              <v-text-field v-model="categoryName" :placeholder="$t('customer.input_category_name')" outlined dense
                :disabled="isSaving" :rules="[rules.required]" />
              <v-btn type="submit" class="primary" :disabled="isSaving">
                <v-icon left>mdi-plus</v-icon>{{ $t('project.add_category') }}
              </v-btn>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-text style="padding: 0;">
            <div class="category" v-if="!isloadData">
              <div class="category-title">{{ $t('project.category_list') }}</div>
              <div class="category-item" v-for="category in categories" :key="category.objectId">
                <div class="category-item-name">
                  {{ category.name }}
                </div>
                <div class="category-item-btn">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-btn icon @click="onEdditDialog(category)">
                          <v-icon color="warning">mdi-pencil</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <div>{{ $t('customer.edit_category_name') }}</div>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-btn icon @click="confirmRemove(category)">
                          <v-icon color="error">mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <div>{{ $t('customer.delete_category') }}</div>
                  </v-tooltip>
                </div>
              </div>
              <div class="category-no-data" v-if="!categories || categories.length == 0">
                {{ $t('customer.no_category') }}
              </div>
            </div>
            <v-card v-else class="d-flex justify-center py-10" elevation="0">
              <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
            </v-card>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <ConfirmDialog v-if="categoryRemove" :loading="isSaving" :disabled="isSaving" :title="$t('validate.confirm_delete_list')"
      :description="`${$t('validate.you_want_to_delete_category_question', { name: categoryRemove.name })}`"
      @onOk="removeCategory(categoryRemove.objectId)" :confirmColor="`error`" v-model="isConfirmRemoved" />
    <v-dialog v-model="isEditDialog" max-width="400px" @keydown.esc="isEditDialog = false"
      @click:outside="isEditDialog = false">
      <v-form @submit.prevent="updateCategory()" ref="form2" :lazy-validation="true" :disabled="isLoading">
        <v-card>
          <v-card-title class="
              d-flex
              justify-space-between
              bg-yellow-500
              text-white
              py-2
            ">
            <div>{{ $t('customer.edit_category_name') }}</div>
            <v-btn icon @click="isEditDialog = false" color="white">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-text-field v-model="formData.name" hide-details :placeholder="$t('asset.category_name')"
              :label="$t('asset.category_name')" outlined no- :disabled="isSaving" :rules="[rules.required]" />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <div v-if="!formData.name" class="warning-message">{{ $t('validate.please_input_category_name_another_format') }}</div>
            <v-spacer></v-spacer>
            <v-btn color="default" elevation="0" :disabled="isSaving" @click="isEditDialog = false">{{ $t('close') }}</v-btn>
            <v-btn type="submit" color="success" elevation="0" :disabled="isSaving || !formData.name" :loading="isSaving">
              <v-icon left>mdi-content-save</v-icon>
              {{ $t('save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar v-model="isSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
    </v-snackbar>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ConfirmDialog from "./ConfirmDialog.vue";
export default {
  components: {
    ConfirmDialog
  },
  props: {
    value: Boolean, // v-model from root,
    projectId: String,
  },
  computed: {
    ...mapState({
      categories: (state) => state.transactionCategory.transactionCategories,
    }),
  },
  watch: {
    value(r) {
      if (r) {
        this.initData()
      }
    },
  },
  data() {
    return {
      items: [
        { text: 'Real-Time', icon: 'mdi-clock' },
        { text: 'Audience', icon: 'mdi-account' },
        { text: 'Conversions', icon: 'mdi-flag' },
      ],
      rules: {
        required: (value) => !!value || this.$t('validate.please_input_data'),
      },
      isLoading: false,
      isloadData: false,
      isError: false,
      isSuccess: false,
      isRemoveDialog: false,
      isSaving: false,
      categoryName: null,
      isEditDialog: false,
      formData: {
        id: null,
        name: null
      },
      isConfirmRemoved: false,
      categoryRemove: null
    };
  },
  methods: {
    ...mapActions({
      removeTransactionCategory: 'transactionCategory/removeTransactionCategory',
      updateTransactionCategory: 'transactionCategory/updateTransactionCategory',
      getTransactionCategoryByProject: 'transactionCategory/getTransactionCategoryByProject',
      createTransactionCategory: 'transactionCategory/createTransactionCategory',
    }),
    async initData() {
      this.isloadData = true
      if (this.$refs.form) this.$refs.form.resetValidation();
      try {
        await this.getTransactionCategoryByProject({ projectId: this.projectId });
        this.isloadData = false
      } catch (err) {
        this.isError = true
        this.isloadData = false
      }
    },
    async addCategory() {
      if (this.$refs.form.validate()) {
        this.isSaving = true
        try {
          await this.createTransactionCategory({
            projectId: this.projectId,
            name: this.categoryName
          });
          this.isSuccess = true
          this.categoryName = null
          this.initData()
          this.isSaving = false
        } catch (err) {
          this.isError = true
          this.isSaving = false
        }
      }
    },
    confirmRemove(category) {
      this.categoryRemove = category
      this.isConfirmRemoved = true
    },
    async removeCategory(id) {
      this.isSaving = true
      try {
        await this.removeTransactionCategory(id);
        this.isSuccess = true
        this.initData()
        this.isSaving = false
        this.isConfirmRemoved = false
        this.categoryRemove = null
      } catch (err) {
        this.isError = true
        this.isSaving = false
        this.isConfirmRemoved = false
        this.categoryRemove = null
      }
    },
    onEdditDialog(category) {
      this.isEditDialog = true
      this.formData.id = category.objectId
      this.formData.name = category.name
      if (this.$refs.form2) this.$refs.form2.resetValidation();
    },
    async updateCategory() {
      if (this.$refs.form2.validate()) {
        this.isSaving = true
        try {
          let data = await this.updateTransactionCategory(this.formData);
          this.isEditDialog = false
          this.isSuccess = true
          this.isSaving = false
          this.$emit("onUpdateCategory", data);
          this.$store.commit("incomeExpense/updateIncomeExpenseCategory", data)
          this.initData()
        } catch (err) {
          this.isError = true
          this.isSaving = false
        }
      }
    },
    dismiss() {
      this.$emit("input", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.category {
  font-size: 15px;

  .category-title {
    padding: 5px 10px;
    font-weight: 600;
    border-bottom: 1px solid rgb(221, 221, 221);
    background: rgba(221, 221, 221, 0.176);
  }

  .category-no-data{
    text-align: center;
    font-size: 18px;
    color: rgb(147, 147, 147);
    padding: 15px 0;
  }
  .category-item {
    display: flex;
    padding: 10px 15px;
    align-items: center;
    border-bottom: 1px solid rgb(221, 221, 221);

    .category-item-name {
      flex: 1;
      line-break: anywhere;
      padding-right: 5px;
      text-indent: 15px;
    }

    .category-item-btn {
      display: flex;
      gap: 2px;
    }
  }
}
</style>